import { gql, TypedDocumentNode } from "@apollo/client";

import {
  ValidateAlertMutation,
  ValidateAlertMutationVariables,
  FraudAlertMutationsMutation,
  FraudAlertMutationsMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { alertFragment } from "src/graphql/anti-fraud/fragments/AlertFragment";
import { usePerformMutation } from "src/graphql/utils";

export const validateComplainAlertMutation = gql`
  mutation validateAlert($id: ID!, $decision: AlertValidationDecision!, $comment: String) {
    validateAlert(id: $id, options: { decision: $decision, comment: $comment }) {
      ...AlertFragment
    }
  }

  ${alertFragment}
` as TypedDocumentNode<ValidateAlertMutation, ValidateAlertMutationVariables>;

export const useValidateComplainAlertMutation = ({ onSuccess }) =>
  usePerformMutation(validateComplainAlertMutation, { onSuccess });

export const confirmFraudAlertMutation = gql`
  mutation fraudAlertMutations(
    $id: ID!
    $amount: Float
    $decision: AlertValidationDecision!
    $fraudTypeCode: String
    $comment: String
    $caseId: ID!
    $identifiersToBlacklist: [IdentifierToBlacklistInput!]!
    $allowLinkedCaseIdentifiers: Boolean!
  ) {
    validateAlert(
      id: $id
      options: {
        decision: $decision
        amount: $amount
        fraudTypeCode: $fraudTypeCode
        comment: $comment
      }
    ) {
      ...AlertFragment
    }
    blacklistCaseIdentifiers(
      caseId: $caseId
      options: {
        identifiersToBlacklist: $identifiersToBlacklist
        allowLinkedCaseIdentifiers: $allowLinkedCaseIdentifiers
      }
    ) {
      id
    }
  }

  ${alertFragment}
` as TypedDocumentNode<FraudAlertMutationsMutation, FraudAlertMutationsMutationVariables>;

export const useConfirmFraudAlertMutation = ({ onSuccess }) =>
  usePerformMutation(confirmFraudAlertMutation, { onSuccess });
